import moment from 'moment';

function valueForKeyorNonCamelCasedKey(key,obj,defaultVal=null){
  if(obj.hasOwnProperty(key)){
    return obj[key];
  } else if(obj.hasOwnProperty(key.toLowerCase())){
    return obj[key.toLowerCase()];
  } else {
    return defaultVal
  }
}

export function marshalAgency(obj){
  return {
    accountingId:valueForKeyorNonCamelCasedKey('accountingId',obj),
    active:valueForKeyorNonCamelCasedKey('active',obj),
    chooseDefaultCost:valueForKeyorNonCamelCasedKey('chooseDefaultCost',obj),
    createdDate:moment(valueForKeyorNonCamelCasedKey('createdDate',obj)).valueOf(),
    defaultCostPerCompletion:valueForKeyorNonCamelCasedKey('defaultCostPerCompletion',obj),
    defaultPaymentMethodId:valueForKeyorNonCamelCasedKey('defaultPaymentMethodId',obj),
    defaultRevenueSplit:valueForKeyorNonCamelCasedKey('defaultRevenueSplit',obj),
    id:valueForKeyorNonCamelCasedKey('id',obj),
    lastModifiedDate:moment(valueForKeyorNonCamelCasedKey('lastModifiedDate',obj)).valueOf(),
    name:valueForKeyorNonCamelCasedKey('name',obj),
    paymentCustomerId:valueForKeyorNonCamelCasedKey('paymentCustomerId',obj),
    qaDefaultCost:valueForKeyorNonCamelCasedKey('qaDefaultCost',obj),
    status:valueForKeyorNonCamelCasedKey('status',obj),
    ratableDefaultCost:valueForKeyorNonCamelCasedKey('ratableDefaultCost',obj),
    thisOrThatDefaultCost:valueForKeyorNonCamelCasedKey('thisOrThatDefaultCost',obj),
    useCostPerCompletion:valueForKeyorNonCamelCasedKey('useCostPerCompletion',obj),
    websiteUrl:valueForKeyorNonCamelCasedKey('websiteUrl',obj)
  }
}

//CLEAN UP FIELDS => contactJSON, email, logoFileName, logoId, logoThumbnailURL, status(?)

export function marshalCampaign(obj){
  return {
    agencyId:valueForKeyorNonCamelCasedKey('agencyId',obj),
    chooseCost:valueForKeyorNonCamelCasedKey('chooseCost',obj),
    companyId:valueForKeyorNonCamelCasedKey('companyId',obj),
    completionText:valueForKeyorNonCamelCasedKey('completionText',obj),
    costPerCompletion:valueForKeyorNonCamelCasedKey('costPerCompletion',obj),
    createdDate:moment(valueForKeyorNonCamelCasedKey('createDate',obj)).valueOf(),
    endDate:moment(valueForKeyorNonCamelCasedKey('endDate',obj)).valueOf(),
    feedImageFileName:valueForKeyorNonCamelCasedKey('feedImageFileName',obj),
    feedImageURL:valueForKeyorNonCamelCasedKey('feedImageURL',obj),
    feedText:valueForKeyorNonCamelCasedKey('feedText',obj),
    id:valueForKeyorNonCamelCasedKey('id',obj),
    lastModifiedDate:moment(valueForKeyorNonCamelCasedKey('lastModifiedDate',obj)).valueOf(),
    lifetimeBudget:valueForKeyorNonCamelCasedKey('lifetimeBudget',obj),
    launchDate:moment(valueForKeyorNonCamelCasedKey('launchDate',obj)).valueOf(),
    name:valueForKeyorNonCamelCasedKey('name',obj),
    paymentMethodId:valueForKeyorNonCamelCasedKey('paymentMethodId',obj),
    previewToken:valueForKeyorNonCamelCasedKey('previewToken',obj),
    qaCost:valueForKeyorNonCamelCasedKey('qaCost',obj),
    ratableCost:valueForKeyorNonCamelCasedKey('ratableCost',obj),
    rejectionReason:valueForKeyorNonCamelCasedKey('rejectionReason',obj),
    rejectionUser:valueForKeyorNonCamelCasedKey('rejectionUser',obj),
    revenueSplit:valueForKeyorNonCamelCasedKey('revenueSplit',obj),
    status:valueForKeyorNonCamelCasedKey('status',obj),
    salesNumber:valueForKeyorNonCamelCasedKey('salesNumber',obj),
    thisOrThatCost:valueForKeyorNonCamelCasedKey('thisOrThatCost',obj),
    useCostPerCompletion:valueForKeyorNonCamelCasedKey('useCostPerCompletion',obj),
    valuePerUser:valueForKeyorNonCamelCasedKey('valuePerUser',obj),
    dcmTag:valueForKeyorNonCamelCasedKey('dcmTag',obj),
    tags:(valueForKeyorNonCamelCasedKey('tags',obj) || []).map(marshalTag),
    geoFilterPredicate:valueForKeyorNonCamelCasedKey('geoFilterPredicate',obj),
    states:valueForKeyorNonCamelCasedKey('states',obj),
    filters:valueForKeyorNonCamelCasedKey('filters',obj),
    useCTA:valueForKeyorNonCamelCasedKey('useCTA',obj),
    ctaColor:valueForKeyorNonCamelCasedKey('ctaColor',obj),
    ctaLink:valueForKeyorNonCamelCasedKey('ctaLink',obj),
    ctaText:valueForKeyorNonCamelCasedKey('ctaText',obj),
    completionImageURL:valueForKeyorNonCamelCasedKey('completionImageURL',obj),
    completionImageFileName:valueForKeyorNonCamelCasedKey('completionImageFileName',obj)
  }
}

//CLEAN UP FIELDS => active, approvalUser (?), approved(?), approvedDate(?), campignText, cioaddeddate, cioid, dailyBudget, description, isDeleted(?), isFunded(?), segmentId, useCostPerCompletion(?)

//ADD FIELDS =>  feedImageId

export function marshalCompany(obj){
  return {
    active:valueForKeyorNonCamelCasedKey('active',obj),
    agencyId:valueForKeyorNonCamelCasedKey('agencyId',obj),
    chooseDefaultCost:valueForKeyorNonCamelCasedKey('chooseDefaultCost',obj),
    createdDate:moment(valueForKeyorNonCamelCasedKey('createDate',obj)).valueOf(),
    contactUserId:valueForKeyorNonCamelCasedKey('contactUserId',obj),
    defaultCostPerCompletion:valueForKeyorNonCamelCasedKey('defaultCostPerCompletion',obj),
    defaultRevenueSplit:valueForKeyorNonCamelCasedKey('defaultRevenueSplit',obj),
    id:valueForKeyorNonCamelCasedKey('id',obj),
    isBrand:valueForKeyorNonCamelCasedKey('isBrand',obj),
    lastModifiedDate:moment(valueForKeyorNonCamelCasedKey('lastModifiedDate',obj)).valueOf(),
    logoFileName:valueForKeyorNonCamelCasedKey('logoFileName',obj),
    logoId:valueForKeyorNonCamelCasedKey('logoId',obj),
    logoThumbnailURL:valueForKeyorNonCamelCasedKey('logoThumbnailURL',obj),
    logoURL:valueForKeyorNonCamelCasedKey('logoURL',obj),
    name:valueForKeyorNonCamelCasedKey('name',obj),
    primaryColor:valueForKeyorNonCamelCasedKey('primaryColor',obj),
    qaDefaultCost:valueForKeyorNonCamelCasedKey('qaDefaultCost',obj),
    ratableDefaultCost:valueForKeyorNonCamelCasedKey('ratableDefaultCost',obj),
    thisOrThatDefaultCost:valueForKeyorNonCamelCasedKey('thisOrThatDefaultCost',obj),
    useCostPerCompletion:valueForKeyorNonCamelCasedKey('useCostPerCompletion',obj)
  }
}

//CLEAN UP FIELDS => accentcolor, contactJSON, contactUserId(?), description, email, filtercampaigns(?), status, websiteURL

export function marshalUser(obj){
  return {
    email:valueForKeyorNonCamelCasedKey('email',obj),
    firstName:valueForKeyorNonCamelCasedKey('firstName',obj),
    id:valueForKeyorNonCamelCasedKey('id',obj),
    isOwner:valueForKeyorNonCamelCasedKey('isOwner',obj),
    isProvider:valueForKeyorNonCamelCasedKey('isProvider',obj),
    lastName:valueForKeyorNonCamelCasedKey('lastName',obj),
    agencyId:valueForKeyorNonCamelCasedKey('agencyId',obj)
  }
}

export function marshalPaymentMethod(obj){
  return {
    active:valueForKeyorNonCamelCasedKey('active',obj),
    agencyId:valueForKeyorNonCamelCasedKey('agencyId',obj),
    createdDate:moment(valueForKeyorNonCamelCasedKey('createdDate',obj)).valueOf(),
    id:valueForKeyorNonCamelCasedKey('id',obj),
    kind:valueForKeyorNonCamelCasedKey('kind',obj),
    last4:valueForKeyorNonCamelCasedKey('last4',obj),
    lastModifiedDate:moment(valueForKeyorNonCamelCasedKey('lastModifiedDate',obj)).valueOf(),
    message:valueForKeyorNonCamelCasedKey('message',obj),
    paymentToken:valueForKeyorNonCamelCasedKey('paymentToken',obj)
  }
}

export function marshalTag(obj){
  return {
    id:valueForKeyorNonCamelCasedKey('id',obj),
    vendorId:valueForKeyorNonCamelCasedKey('vendorId',obj),
    type:valueForKeyorNonCamelCasedKey('type',obj),
    tag:valueForKeyorNonCamelCasedKey('tag',obj),
    vendorKey:valueForKeyorNonCamelCasedKey('vendorKey',obj),
    parameters:valueForKeyorNonCamelCasedKey('parameters',obj)
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/marshallers.js